import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Pharmacy: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M20.843 20.2558C21.2611 21.5476 20.2979 22.8716 18.9402 22.8716H5.06055C3.7028 22.8716 2.73966 21.5476 3.15772 20.2558L4.49311 16.1294C4.75221 15.3288 4.75221 14.4668 4.49311 13.6662L3.15772 9.53978C2.73967 8.24799 3.70281 6.92398 5.06055 6.92398H18.9402C20.2979 6.92398 21.2611 8.24799 20.843 9.53978L19.5076 13.6662C19.2485 14.4668 19.2485 15.3288 19.5076 16.1294L20.843 20.2558Z"
                {...pathProps}
            />
            <IconPath
                d="M10.4744 17.9971C10.4744 18.5494 10.9221 18.9971 11.4744 18.9971H12.5294C13.0817 18.9971 13.5294 18.5494 13.5294 17.9971V16.4253H15.1024C15.6547 16.4253 16.1024 15.9776 16.1024 15.4253V14.3703C16.1024 13.818 15.6547 13.3703 15.1024 13.3703H13.5294V11.7986C13.5294 11.2463 13.0817 10.7986 12.5294 10.7986H11.4744C10.9221 10.7986 10.4744 11.2463 10.4744 11.7986V13.3703H8.90388C8.35159 13.3703 7.90388 13.818 7.90388 14.3703V15.4253C7.90388 15.9776 8.35159 16.4253 8.90388 16.4253H10.4744V17.9971Z"
                {...pathProps}
            />
            <IconPath
                d="M15.5767 2.74067L13.5118 6.92418H18.7872L19.3959 4.06677C19.61 3.06166 19.042 2.05444 18.0711 1.71764C17.1006 1.381 16.0313 1.81955 15.5767 2.74067Z"
                {...pathProps}
            />
        </IconSVG>
    );
};
